// Bundle-product behaviors on PDP:
//   * grouped-cart price/availability sync (zds_bundle_price ajax)
//   * related-products-by-variation visibility toggling

import { getAjaxUrl } from './lib/ajax.js';

// === grouped bundle PDP form ===
// Mirrors child-product select values into hidden attribute_ inputs so a fast
// submit goes through with valid WC variation payload, and fetches a server-
// computed price (zds_bundle_price) every time the user changes a selection.

function zds_log() {
    if (!window.zds_bundle_debug) return;
    try { console.log.apply(console, arguments); } catch (e) {}
}

function parse_select_name(name) {
    // bundle_variations[row_key][pa_single-module] — row_key may be numeric id or bundle_row_key hash
    var m = (name || '').match(/^bundle_variations\[([^\]]+)\]\[([^\]]+)\]$/);
    if (!m) return null;
    return { child_id: m[1], attr_key: m[2] };
}

function ensure_attribute_hidden($form, child_id, attr_key, value) {
    var canonical_key = attr_key.indexOf('attribute_') === 0 ? attr_key : ('attribute_' + attr_key);
    var hidden_name = 'bundle_variations[' + child_id + '][' + canonical_key + ']';

    var $existing = $form.find('input[type="hidden"][name="' + hidden_name.replace(/"/g, '\\"') + '"]');
    if (!$existing.length) {
        $existing = jQuery('<input type="hidden" />')
            .attr('name', hidden_name)
            .attr('data_zds_bundle_hidden', '1')
            .appendTo($form);
    }
    $existing.val(value == null ? '' : String(value));
}

function sync_hidden_attributes($form) {
    $form.find('select[name^="bundle_variations["]').each(function() {
        var meta = parse_select_name(this.name);
        if (!meta) return;
        ensure_attribute_hidden($form, meta.child_id, meta.attr_key, jQuery(this).val());
    });
}

function find_bundle_form($ctx) {
    if ($ctx && $ctx.length) {
        var $f = $ctx.closest('form.grouped-cart');
        if ($f.length) return $f;
    }
    return jQuery('form.grouped-cart').first();
}

function init_for_form($form) {
    if (!$form || !$form.length) return;
    if ($form.data('zds_bundle_inited')) return;
    $form.data('zds_bundle_inited', 1);

    var $product_id_input = $form.find('input[name="add-to-cart"]').first();
    if (!$product_id_input.length) {
        zds_log('[zds_bundle] no add-to-cart hidden input found');
        return;
    }

    var product_id = parseInt($product_id_input.val(), 10);
    if (!product_id) {
        zds_log('[zds_bundle] invalid product_id');
        return;
    }

    var nonce = $form.find('input[name="_wpnonce"]').val() || '';
    if (!nonce) {
        zds_log('[zds_bundle] missing _wpnonce');
        return;
    }

    var $scope = $form.closest('.product');
    if (!$scope.length) $scope = $form.parent();

    var $price_el = $scope.find('.bundle_total_price.price').first();
    if (!$price_el.length) $price_el = $scope.find('.bundle_total_price').first();

    var $notice_el = $scope.find('.bundle_price_notice').first();
    var $asterisk_el = $scope.find('.bundle_asterisk').first();
    var $license_el = $scope.find('.woocommerce-variation-license').first();

    var $add_btn = $form.find('button.single_add_to_cart_button, button[type="submit"]').first();
    if (!$add_btn.length) {
        zds_log('[zds_bundle] no add_to_cart button found');
        return;
    }

    function set_add_to_cart_enabled(is_enabled) {
        if (is_enabled) {
            $add_btn.prop('disabled', false).removeClass('disabled').attr('aria-disabled', 'false');
        } else {
            $add_btn.prop('disabled', true).addClass('disabled').attr('aria-disabled', 'true');
        }
    }

    function serialize_bundle_variations() {
        var out = {};
        $form.find('select[name^="bundle_variations["]').each(function() {
            var meta = parse_select_name(this.name);
            if (!meta) return;

            var v = jQuery(this).val();
            if (!out[meta.child_id]) out[meta.child_id] = {};
            out[meta.child_id][meta.attr_key] = v;
        });
        return out;
    }

    function any_bundle_select_unset() {
        var unset = false;
        $form.find('select[name^="bundle_variations["]').each(function() {
            var v = jQuery(this).val();
            if (!v) { unset = true; return false; }
        });
        return unset;
    }

    var ajax_url = getAjaxUrl();
    var last_payload = '';
    var inflight_xhr = null;
    var debounce_timer = null;

    function update_bundle_ui(data) {
        if (!data) return;

        if (parseInt(data.license_found, 10) === 1) {
            if ($asterisk_el.length) $asterisk_el.show();
            if ($license_el.length) $license_el.show();
        } else {
            if ($asterisk_el.length) $asterisk_el.hide();
            if ($license_el.length) $license_el.hide();
        }

        // Respect "complete" from server if present.
        var is_complete = true;
        if (data.complete != null) {
            is_complete = (parseInt(data.complete, 10) === 1);
        } else {
            is_complete = !!data.price_html;
        }

        if (is_complete && data.price_html) {
            if ($notice_el.length) $notice_el.hide();
            if ($price_el.length) $price_el.removeClass('zds_bundle_price_incomplete').html(data.price_html);
            set_add_to_cart_enabled(true);
        } else {
            if ($price_el.length) $price_el.addClass('zds_bundle_price_incomplete').html('');
            set_add_to_cart_enabled(false);
            if ($notice_el.length) $notice_el.hide();
        }
    }

    function fetch_price() {
        sync_hidden_attributes($form);

        if (any_bundle_select_unset()) {
            if ($price_el.length) $price_el.addClass('zds_bundle_price_incomplete').html('');
            set_add_to_cart_enabled(false);

            if ($asterisk_el.length) $asterisk_el.hide();
            if ($license_el.length) $license_el.hide();
            if ($notice_el.length) $notice_el.hide();

            return;
        }

        if ($notice_el.length) $notice_el.text('Loading...').show();
        if ($asterisk_el.length) $asterisk_el.hide();
        if ($license_el.length) $license_el.hide();
        if ($price_el.length) $price_el.html('');

        var bundle_variations = serialize_bundle_variations();

        var payload_fingerprint = JSON.stringify({
            product_id: product_id,
            bundle_variations: bundle_variations
        });

        if (payload_fingerprint === last_payload) return;
        last_payload = payload_fingerprint;

        if (inflight_xhr && inflight_xhr.readyState !== 4) {
            try { inflight_xhr.abort(); } catch (e) {}
        }

        inflight_xhr = jQuery.ajax({
            url: ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'zds_bundle_price',
                _wpnonce: nonce,
                product_id: product_id,
                bundle_variations: bundle_variations
            }
        })
        .done(function(res) {
            if (!res || !res.success || !res.data) {
                zds_log('[zds_bundle] bad response', res);
                if ($notice_el.length) $notice_el.text('Could not load price').show();
                set_add_to_cart_enabled(false);
                return;
            }
            update_bundle_ui(res.data);
        })
        .fail(function(xhr) {
            zds_log('[zds_bundle] ajax fail', xhr.status, xhr.responseText);
            if ($notice_el.length) $notice_el.text('Could not load price').show();
            set_add_to_cart_enabled(false);
        });
    }

    function schedule_fetch() {
        if (debounce_timer) window.clearTimeout(debounce_timer);
        debounce_timer = window.setTimeout(fetch_price, 120);
    }

    set_add_to_cart_enabled(false);

    $form.off('submit.zds_bundle');
    $form.on('submit.zds_bundle', function() {
        sync_hidden_attributes($form);

        if (any_bundle_select_unset()) {
            zds_log('[zds_bundle] submit blocked: selections incomplete');
            return false;
        }
        return true;
    });

    zds_log('[zds_bundle] init ok', { product_id: product_id });
    schedule_fetch();

    $form.data('zds_bundle_schedule_fetch', schedule_fetch);
}

function init_all_visible_forms() {
    jQuery('form.grouped-cart').each(function() {
        init_for_form(jQuery(this));
    });
}

function init_bundle_pdp_form() {
    var zds_grouped_product = window.zds_grouped_product || {};
    if (!zds_grouped_product || !zds_grouped_product.id) return;

    // Delegated change handlers survive ajax DOM swaps.
    jQuery(document).off('change.zds_bundle', 'form.grouped-cart select[name^="bundle_variations["]');
    jQuery(document).on('change.zds_bundle', 'form.grouped-cart select[name^="bundle_variations["]', function() {
        var $form = find_bundle_form(jQuery(this));
        init_for_form($form);
        sync_hidden_attributes($form);

        var schedule_fetch = $form.data('zds_bundle_schedule_fetch');
        if (typeof schedule_fetch === 'function') schedule_fetch();
    });

    jQuery(document).off('change.zds_bundle_qty', 'form.grouped-cart input.qty');
    jQuery(document).on('change.zds_bundle_qty', 'form.grouped-cart input.qty', function() {
        var $form = find_bundle_form(jQuery(this));
        init_for_form($form);

        var schedule_fetch = $form.data('zds_bundle_schedule_fetch');
        if (typeof schedule_fetch === 'function') schedule_fetch();
    });

    init_all_visible_forms();
}

// === related products by variation ===
// Each [data_zd_related_wrap] block embeds a JSON map of which product IDs
// belong to "static" mode (always-on) or to "variation_map" mode (per-variation
// curated list). On PDP variation change, the visible cards swap to match.

function init_related_by_variation() {
    jQuery('[data_zd_related_wrap]').each(function() {
        var $wrap = jQuery(this);
        var $grid = $wrap.find('[data_zd_related_grid]');
        var $cards = $grid.find('[data_zd_related_card][data-product-id]');
        var $btn = $grid.find('[data_zd_related_show_all]');

        var read_map = function() {
            var el = $wrap.find('script[data_zd_related_map]').get(0);
            if (!el) return null;

            try {
                return JSON.parse(el.textContent || '{}') || {};
            } catch (e) {
                return null;
            }
        };

        var get_limit = function(map) {
            var a = parseInt(String($wrap.attr('data_list_limit') || ''), 10);
            if (Number.isFinite(a) && a > 0) return a;

            var b = parseInt(String((map && map.list_limit) || ''), 10);
            if (Number.isFinite(b) && b > 0) return b;

            return 3;
        };

        var get_mode = function(map) {
            var from_attr = String($wrap.attr('data_zd_mode') || '').trim();
            if (from_attr) return from_attr;

            var from_map = String((map && map.mode) || '').trim();
            if (from_map) return from_map;

            return 'static';
        };

        var get_active_variation_id = function() {
            var from_attr = String($wrap.attr('data-active-variation-id') || '').trim();
            if (from_attr) return from_attr;

            var $form = jQuery('form.variations_form');
            if (!$form.length) return '';

            var raw = $form.find('input[name="variation_id"]').val();
            var id = parseInt(String(raw || ''), 10);

            return Number.isFinite(id) && id > 0 ? String(id) : '';
        };

        var get_ids_for_current = function(map, variation_id) {
            var parent_ids = Array.isArray(map && map.parent) ? map.parent.map(String) : [];
            if (!variation_id) return parent_ids;

            var variations = map && map.variations && typeof map.variations === 'object'
                ? map.variations
                : {};

            var v_ids = Array.isArray(variations[String(variation_id)])
                ? variations[String(variation_id)].map(String)
                : [];

            return v_ids.length ? v_ids : parent_ids;
        };

        var hide_all = function() {
            $cards.addClass('is_hidden').each(function() {
                this.style.removeProperty('opacity');
                this.style.removeProperty('transform');
            });

            $btn.stop(true, true).addClass('is_hidden').hide();
        };

        var sync_wrap_visibility = function() {
            var visible_count = $cards.filter(':not(.is_hidden)').length;
            if (visible_count > 0) $wrap.show();
            else $wrap.hide();
        };

        var apply_static_state = function(map) {
            hide_all();

            var limit = get_limit(map);

            $cards.each(function(idx) {
                if (idx < limit) this.classList.remove('is_hidden');
            });

            if ($cards.length > limit) {
                $btn.stop(true, true).removeClass('is_hidden').show();
            }

            sync_wrap_visibility();
        };

        var apply_variation_state = function(map) {
            var variation_id = get_active_variation_id();
            var ids = get_ids_for_current(map, variation_id);
            var wanted = {};

            ids.forEach(function(id) { wanted[String(id)] = true; });

            hide_all();

            var $matched = $cards.filter(function() {
                var pid = String(this.getAttribute('data-product-id') || '');
                return !!wanted[pid];
            });

            var limit = get_limit(map);

            $matched.each(function(idx) {
                if (idx < limit) this.classList.remove('is_hidden');
            });

            if ($matched.length > limit) {
                $btn.stop(true, true).removeClass('is_hidden').show();
            }

            sync_wrap_visibility();
        };

        var apply_state = function() {
            var map = read_map() || {};
            var mode = get_mode(map);

            if (mode === 'variation_map') {
                apply_variation_state(map);
                return;
            }

            apply_static_state(map);
        };

        var show_all_current = function() {
            var map = read_map() || {};
            var mode = get_mode(map);

            var $matched = $cards;

            if (mode === 'variation_map') {
                var variation_id = get_active_variation_id();
                var ids = get_ids_for_current(map, variation_id);
                var wanted = {};

                ids.forEach(function(id) { wanted[String(id)] = true; });

                $matched = $cards.filter(function() {
                    var pid = String(this.getAttribute('data-product-id') || '');
                    return !!wanted[pid];
                });
            }

            $btn.stop(true, true).fadeOut(150, function() {
                $btn.addClass('is_hidden').hide();
            });

            var $hidden = $matched.filter('.is_hidden');

            $hidden.each(function(i) {
                var el = this;
                el.classList.remove('is_hidden');
                el.style.opacity = '0';
                el.style.transform = 'translateY(10px)';
                // eslint-disable-next-line no-unused-expressions
                el.offsetHeight;

                window.setTimeout(function() {
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                }, i * 60);
            });

            sync_wrap_visibility();
        };

        apply_state();

        $wrap.on('click', '[data_zd_related_show_all]', function(e) {
            e.preventDefault();
            show_all_current();
        });

        var map = read_map() || {};
        var mode = get_mode(map);

        if (mode === 'variation_map') {
            var $form = jQuery('form.variations_form');

            if ($form.length) {
                $form.on('found_variation', function(e, variation) {
                    var vid = variation && variation.variation_id ? String(variation.variation_id) : '';
                    $wrap.attr('data-active-variation-id', vid);
                    apply_state();
                });

                $form.on('woocommerce_variation_has_changed', function() {
                    apply_state();
                });

                $form.on('reset_data', function() {
                    $wrap.attr('data-active-variation-id', '');
                    apply_state();
                });
            }
        }
    });
}

export function init() {
    init_bundle_pdp_form();
    init_related_by_variation();
}
